import { sendToken } from '../../services/api';
import { wasHandledGlobally } from '../../services/client';
import { Button, Flex, Heading, Input, Stack, useToast } from '@chakra-ui/react';
import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CampoForm } from '../../components/CampoForm';
import { ErrosForm, useErrosForm } from '../../hooks/useErrosForm';
import { emailInvalido, vazio } from '../../utils/validacao';
import { FUNDO_AUTH } from '../../utils/fundoAuth';

type Campo = 'username';

export default function ForgotPassword() {
	const [ username, setUsername ] = useState('');
	const [ isLoading, setIsLoading ] = useState(false);
	const { erros, validar, limparErro } = useErrosForm<Campo>();
	const toast = useToast();
	const navigate = useNavigate();

	const montarErros = (): ErrosForm<Campo> => {
		const encontrados: ErrosForm<Campo> = {};

		if (vazio(username)) {
			encontrados.username = 'Email é obrigatório!';
		} else if (emailInvalido(username)) {
			encontrados.username = 'Informe um email válido.';
		}

		return encontrados;
	};

	// Antes nao havia validacao nenhuma aqui: o botao disparava send-code mesmo com
	// o campo vazio, gastando uma das 5 tentativas por minuto do rate limit.
	const handleSendToken = (event: FormEvent) => {
		event.preventDefault();
		if (!validar(montarErros())) return;

		const email = username.trim();
		setIsLoading(true);
		sendToken(email)
			.then(() => {
				setIsLoading(false);
				navigate('/change-password/' + email);
			})
			.catch((error) => {
				setIsLoading(false);
				if (wasHandledGlobally(error)) return;
				toast({
					title: `Não foi possível enviar o código.`,
					status: 'error',
					isClosable: true
				});
			});
	};

	return (
		<Stack
			minH={'100vh'}
			bgImage={FUNDO_AUTH}
			bgSize={'cover'}
			bgPosition={'center'}
			bgRepeat={'no-repeat'}
		>
			<Flex p={8} flex={1} align={'center'} justify={'center'}>
				<Stack
					as={'form'}
					onSubmit={handleSendToken}
					noValidate
					spacing={4}
					w={'full'}
					maxW={'md'}
					align={'center'}
					justify={'center'}
					backgroundColor="blue.900"
					borderWidth="1px"
					borderColor="whiteAlpha.200"
					padding={'40px'}
					borderRadius="18px"
					boxShadow="0 30px 60px -30px rgba(0,0,0,0.75)"
					color="white"
				>
					<Heading fontSize={'2xl'}>Recupere sua senha</Heading>

					<CampoForm label="Digite seu email" htmlFor="email" erro={erros.username} ocultarAsterisco>
						<Input
							id="email"
							type="email"
							autoComplete="email"
							placeholder="seuemail@seuemail.com"
							value={username}
							onChange={(e) => {
								setUsername(e.target.value);
								limparErro('username');
							}}
							disabled={isLoading}
							color="white"
							borderColor="whiteAlpha.300"
							bgColor="whiteAlpha.100"
							_placeholder={{ color: 'whiteAlpha.500' }}
						/>
					</CampoForm>

					<Stack width="100%" gap={'5px'}>
						<Button colorScheme={'blue'} variant={'solid'} type="submit" isLoading={isLoading}>
							Enviar código por e-mail
						</Button>
						<Button
							type="button"
							colorScheme="blue"
							variant="outline"
							onClick={() => navigate('/')}
							isDisabled={isLoading}
						>
							Voltar
						</Button>
					</Stack>
				</Stack>
			</Flex>
		</Stack>
	);
}
